import {FC} from 'react'

import {Text, TextFontWeight, TextVariant} from '@/components/common/content/Text'
import {LocalizedNumberFormat} from '@/components/common/LocalizedNumberFormat'
import {usePreferences} from '@/components/context/Preferences'
import {
  getBrandEnforcementPriceListItems,
  getBrandMonitoringPriceListItems,
  getPricingContent,
  PriceListItem,
} from '@/content/pricing'
import {useTranslation} from '@/i18n'
import {theme} from '@/theme/theme'

import {PricingTableLayout} from '../PricingTableLayout'
import {PricingTableRow} from '../PricingTableRow'
import {PricingTableSection} from '../PricingTableSection'

export const PricingBrandProtectionTab: FC = () => {
  const {t} = useTranslation()
  const {currency} = usePreferences()
  const {subtitle, monitoring, enforcement} = getPricingContent().brandProtection

  const sections: {title: string; items: PriceListItem[]}[] = [
    {title: t(monitoring.title), items: getBrandMonitoringPriceListItems(currency)},
    {title: t(enforcement.title), items: getBrandEnforcementPriceListItems(currency)},
  ]

  return (
    <>
      <PricingTableLayout subtitle={<Text align="center">{t(subtitle)}</Text>} fullWidth>
        {sections.map(({title, items}) => (
          <PricingTableSection key={title} title={title}>
            {items.map(({key, title, titleValues, description, linkUrl, priceNote, price}) => (
              <PricingTableRow
                key={key}
                title={t(title, titleValues)}
                description={description && t(description)}
                linkUrl={linkUrl}
              >
                <div className="price">
                  <Text fontWeight={TextFontWeight.bold}>
                    <LocalizedNumberFormat value={price} type="currency" currency={currency} />
                    {priceNote && (
                      <Text
                        variant={TextVariant.caption}
                        fontWeight={TextFontWeight.regular}
                        color={theme.palette.text.light}
                        element="span"
                      >
                        {`/${t(priceNote)}`}
                      </Text>
                    )}
                  </Text>
                </div>
              </PricingTableRow>
            ))}
          </PricingTableSection>
        ))}
      </PricingTableLayout>

      <style jsx>{`
        .price {
          white-space: nowrap;
          text-align: right;
          margin-left: ${theme.spacing[3]};
        }
      `}</style>
    </>
  )
}
